package com.wintermar.inspection.feature.presentation.inspection.complete.widget.header

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.component.button.iconButtonContent
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.HeaderWideContainer
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.confirm_qhse_approval
import inspection.composeapp.generated.resources.download_pdf
import inspection.composeapp.generated.resources.ic_arrow_left_line
import org.jetbrains.compose.resources.stringResource

@Composable
fun InspectionCompleteHeaderWide(
    onDownloadPdf: () -> Unit,
    onShowConfirmApproval: () -> Unit,
    onBack: () -> Unit
) {
    val dimension: AppDimension = LocalAppTheme.current.dimension
    val color: ThemeColor = LocalAppTheme.current.color

    HeaderWideContainer(horizontalPadding = dimension.spacing.space2) {
        IconButton(
            icon = Res.drawable.ic_arrow_left_line,
            backgroundColor = color.surface.neutral.subtlest.default,
            tint = color.icon.default,
            contentValue = iconButtonContent().copy(
                borderColor = color.border.default,
                borderWidth = 1.dp,
                width = dimension.size.size7,
                height = dimension.size.size7
            ),
            onClick = onBack
        )
        Spacer(modifier = Modifier.weight(1f))
        Button(
            buttonVariant = ButtonVariant.SmallOutline,
            text = stringResource(Res.string.download_pdf),
            onClick = onDownloadPdf
        )
        Button(
            buttonVariant = ButtonVariant.SmallPrimary,
            text = stringResource(Res.string.confirm_qhse_approval),
            onClick = onShowConfirmApproval
        )
    }
    HorizontalDivider(modifier = Modifier.fillMaxWidth(), color = color.border.subtle)
}
